var _a, _b;
import { handleActions } from 'redux-actions';
import { measuredCookieReduxKey, cookieKey } from './constants';
import { initializeMeasuredCookie } from './actions';
import { MeasuredCookie } from './MeasuredCookie';
var actionHandler = handleActions((_a = {},
    _a[initializeMeasuredCookie.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload && payload.cookies[cookieKey]
            ? MeasuredCookie.decode(payload.cookies[cookieKey])
            : state;
    },
    _a), {});
export default (_b = {},
    _b[measuredCookieReduxKey] = actionHandler,
    _b);
//# sourceMappingURL=reducer.js.map